// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * Rana backend API
 * The API service for Rana.
 *
 * The version of the OpenAPI document: v1-alpha
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues, parseDate, parseDateTime, serializeDate, serializeDateTime } from "../runtime";
import type { User } from "./User";
import { UserFromJSON, UserFromJSONTyped, UserToJSON, UserToJSONTyped } from "./User";

/**
 *
 * @export
 * @interface PublicationVersionSummary
 */
export interface PublicationVersionSummary {
  /**
   *
   */
  id: string;
  /**
   *
   */
  publicationId: string;
  /**
   *
   */
  version: number;
  /**
   *
   */
  createdAt: Date;
  /**
   *
   */
  creator: User;
}

/**
 * Check if a given object implements the PublicationVersionSummary interface.
 */
export function instanceOfPublicationVersionSummary(
  value: object
): value is PublicationVersionSummary {
  if (!("id" in value) || value["id"] === undefined) return false;
  if (
    (!("publicationId" in (value as Record<string, any>)) &&
      !("publication_id" in (value as Record<string, any>))) ||
    ((value as Record<string, any>)["publicationId"] === undefined &&
      (value as Record<string, any>)["publication_id"] === undefined)
  )
    return false;
  if (!("version" in value) || value["version"] === undefined) return false;
  if (
    (!("createdAt" in (value as Record<string, any>)) &&
      !("created_at" in (value as Record<string, any>))) ||
    ((value as Record<string, any>)["createdAt"] === undefined &&
      (value as Record<string, any>)["created_at"] === undefined)
  )
    return false;
  if (!("creator" in value) || value["creator"] === undefined) return false;
  return true;
}

export function PublicationVersionSummaryFromJSON(json: any): PublicationVersionSummary {
  return PublicationVersionSummaryFromJSONTyped(json, false);
}

export function PublicationVersionSummaryFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): PublicationVersionSummary {
  if (json == null) {
    return json;
  }
  return {
    id: json["id"],
    publicationId: json["publication_id"],
    version: json["version"],
    createdAt: json["created_at"] == null ? json["created_at"] : parseDateTime(json["created_at"]),
    creator: UserFromJSON(json["creator"]),
  };
}

export function PublicationVersionSummaryToJSON(json: any): PublicationVersionSummary {
  return PublicationVersionSummaryToJSONTyped(json, false);
}

export function PublicationVersionSummaryToJSONTyped(
  value?: PublicationVersionSummary | null,
  ignoreDiscriminator: boolean = false
): any {
  if (value == null) {
    return value;
  }

  return {
    id: value["id"],
    publication_id: value["publicationId"],
    version: value["version"],
    created_at:
      value["createdAt"] == null ? value["createdAt"] : serializeDateTime(value["createdAt"]),
    creator: UserToJSON(value["creator"]),
  };
}
